/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespPromoModuleSecondaryOld_homepage$ref = any;
export type HpRespPromoModuleSecondaryOld_homepage = {
    readonly promoSecondaryModule: ({
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly link: string | null;
            readonly imageUrl?: string | null;
            readonly mobileImageUrl?: string | null;
            readonly isLinkable: boolean | null;
        } | null> | null;
    } & ({
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly link: string | null;
            readonly imageUrl?: string | null;
            readonly mobileImageUrl?: string | null;
            readonly isLinkable: boolean | null;
        } | null> | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null;
    readonly promoPrimaryModule: ({
        readonly totalItemsCount?: number | null;
    } & ({
        readonly totalItemsCount: number | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null;
    readonly " $refType": HpRespPromoModuleSecondaryOld_homepage$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "HpRespPromoModuleSecondaryOld_homepage",
    "type": "Homepage",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isMobile",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": "promoSecondaryModule",
            "name": "module",
            "storageKey": "module(type:\"promoSecondary\")",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "promoSecondary"
                }
            ],
            "concreteType": null,
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "type": "PromoModule",
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PromoItem",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cmsId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "link",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isLinkable",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "condition": "isMobile",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "imageUrl",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "isMobile",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "mobileImageUrl",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": "promoPrimaryModule",
            "name": "module",
            "storageKey": "module(type:\"promoPrimary\")",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "promoPrimary"
                }
            ],
            "concreteType": null,
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "type": "PromoModule",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "totalItemsCount",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'fccdf51142b70807944802c42685e02f';
export default node;
